import { useNavigate } from "react-router-dom";

/**
 * A back button that goes where the person came from.
 *
 * `navigate("..")` is not "back": it is route-relative, and from an index route
 * it climbs to the grandparent — from /products that is the region root, which
 * lands on whichever page the role can open first. So: step back through
 * history when this tab has any, and only when it opened straight onto this
 * page (a shared link, a fresh tab) fall back to the parent list instead.
 *
 * React Router keeps its position in `history.state.idx`; 0 means this is the
 * first entry, and stepping back from there would leave the app.
 */
export function useGoBack(fallback: string) {
  const navigate = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(fallback);
  };
}
